import { PropsWithChildren, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLogOutMutation } from "../data/queries";
import { useAuthTokensAtom } from "../data/store";
import { isTokenExpired } from "../model/Jwt";

const Auth = ({ children }: PropsWithChildren) => {
  const [authTokens] = useAuthTokensAtom();
  const navigate = useNavigate();
  const { mutate: logOut, isPending: isLoggingOut } = useLogOutMutation();

  useEffect(() => {
    if (authTokens && isTokenExpired(authTokens.refreshJwt)) {
      logOut({}); // Sets user to null
    }
    if (!authTokens) {
      navigate("/login");
    }
  }, [authTokens, navigate, logOut]);

  if (!authTokens || isLoggingOut) {
    return null;
  }

  return children;
};

export default Auth;
